import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from '../auth.service'

@Component({
  selector: 'app-sign-in',
  template: '',
})
export class SignInComponent implements OnInit {

  constructor(
    private auth: AuthService,
    private router: Router,
  ) { }

  ngOnInit() {
    console.log('sigin', location.href)
    this.auth.verifyEmailLink(location.href)
    .then(() => this.router.navigateByUrl('/secured') )
    .catch(() => this.router.navigateByUrl('/secured') )
  }

}
